export function arrayBufferMemcpy(target, source, byteOffset = 0, byteLength = source.byteLength) {
    const T = byteLength % 8 === 0 ? Float64Array :
              byteLength % 4 === 0 ? Float32Array :
              byteLength % 2 === 0 ? Uint16Array : Uint8Array;
    const src = asTypedArray(T, source, byteLength / T.BYTES_PER_ELEMENT);
    const dst = asTypedArray(T, target, target.byteLength / T.BYTES_PER_ELEMENT);
    dst.set(src, byteOffset / T.BYTES_PER_ELEMENT);
    return dst;
}

export function asTypedArray(TypedArray, data, length) {
    if (data instanceof TypedArray) return data;
    if (data instanceof ArrayBuffer) return new TypedArray(data, 0, length);
    if (!data) return new TypedArray(length);
    return !data || !ArrayBuffer.isView(data) ?
        new TypedArray(data || [], 0, length) :
        new TypedArray(data.buffer, data.byteOffset, Math.min(
            length, data.byteLength / TypedArray.BYTES_PER_ELEMENT
        ));
}
